import { CollapsibleFieldTemplateProps } from "@/src/types/components/ScenarioForm";
import { FieldProps } from "@rjsf/utils";
import { Tooltip } from "@/src/components/Tooltip";

const GridFieldTemplate = ({
    help,
    errors,
    properties,
    schema,
}: Omit<CollapsibleFieldTemplateProps, 'formData'>) => {
    const orderedProperties = [...properties].sort((firstProperty, secondProperty) => {
        const firstOrder = (schema?.properties?.[firstProperty.name] as { order?: number } | undefined)?.order ?? 0;
        const secondOrder = (schema?.properties?.[secondProperty.name] as { order?: number } | undefined)?.order ?? 0;
        return firstOrder - secondOrder;
    });
    const lastProperty = orderedProperties[orderedProperties.length - 1];
    const lastPropertyTitle = lastProperty
        ? (schema?.properties?.[lastProperty.name] as { title?: string } | undefined)?.title
        : undefined;
    const hasToelichtingAsLastColumn = lastPropertyTitle?.trim().toLowerCase() === "toelichting";
    const gridColumnsClass = hasToelichtingAsLastColumn
        ? ""
        : `lg:grid-cols-${Math.min(orderedProperties.length, 12)}`;
    const gridTemplateColumns = hasToelichtingAsLastColumn
        ? orderedProperties.length > 1
            ? `minmax(0, 1.5fr) repeat(${orderedProperties.length - 2}, minmax(0, 1fr)) minmax(0, 3fr)`
            : "minmax(0, 3fr)"
        : undefined;

    return (
        <div className="form-group">
            {/* Grid layout for child inputs */}
            <div
                className={`grid grid-cols-1 md:grid-cols-2 ${gridColumnsClass} print:grid-cols-${Math.min(orderedProperties.length, 12)} gap-4 hnn-grid-row${hasToelichtingAsLastColumn ? " hnn-prestaties-grid--toelichting" : ""}`}
                style={gridTemplateColumns ? { gridTemplateColumns } : undefined}
            >
             
                {orderedProperties.map((prop: FieldProps, index: number) => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const tooltip = (schema?.properties as any)?.[prop.name]?.tooltip as string | undefined;
                    return (
                        <div key={index} className="relative grid-item hnn-grid-item">
                            {prop.content}
                            {tooltip && (
                                <span className="absolute top-2 right-2">
                                    <Tooltip title={tooltip} small />
                                </span>
                            )}
                        </div>
                    );
                })}
            </div>

            {errors && <div className="text-red-500 text-sm mt-2">{errors}</div>}
            {help && <div className="text-gray-500 text-sm mt-2">{help}</div>}
        </div>
    );
};

export default GridFieldTemplate;
